module.exports = __webpack_public_path__ + "static/media/jialishan_web.ffa1569b.webp";